import { render, staticRenderFns } from "./login-tel.vue?vue&type=template&id=9dd4cc3e&scoped=true&"
import script from "./login-tel.vue?vue&type=script&lang=js&"
export * from "./login-tel.vue?vue&type=script&lang=js&"
import style0 from "./login-tel.vue?vue&type=style&index=0&id=9dd4cc3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd4cc3e",
  null
  
)

export default component.exports